import * as React from 'react';

const ReusableBox24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M3 2.25a.75.75 0 0 0-.75.75v4c0 .414.336.75.75.75h.25V20A2.75 2.75 0 0 0 6 22.75h3a.75.75 0 0 0 0-1.5H6c-.69 0-1.25-.56-1.25-1.25V7.75h14.5V11a.75.75 0 0 0 1.5 0V7.75H21a.75.75 0 0 0 .75-.75V3a.75.75 0 0 0-.75-.75zm17.25 4H3.75v-2.5h16.5z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12.75 14v1.065c1.1-.998 2.488-1.815 4.014-1.815 2.015 0 3.757 1.182 4.683 2.93.483.969-.78 1.651-1.326.702-.668-1.263-1.893-2.132-3.357-2.132-1.183 0-2.251.722-3.087 1.5H15c.967 0 .967 1.5 0 1.5h-3a.75.75 0 0 1-.75-.75v-3c0-.967 1.5-.967 1.5 0m7.5 9c0 .967 1.5.967 1.5 0v-3a.75.75 0 0 0-.75-.75h-3c-.967 0-.967 1.5 0 1.5h1.323c-.836.778-1.904 1.5-3.087 1.5-1.562 0-2.89-1.007-3.494-2.416-.403-.942-1.785-.357-1.379.59.838 1.954 2.715 3.326 4.873 3.326 1.526 0 2.914-.817 4.014-1.815z"
  }
));
ReusableBox24.Size = 24;
ReusableBox24.Title = "ReusableBox";

export { ReusableBox24 as default };
